// NOTE: Impugned Tracker has no backend yet. Every action here operates on an
// in-memory `state.allImpugned` array instead of calling the API, so the full
// create/list/search/paginate/delete flow works end-to-end on the frontend.
// Action names, payload shapes, and resolved response shapes ({ success, data, meta })
// intentionally mirror the real axios-backed trackers (fir-tracker-store.js etc.),
// so swapping the body of each action for a real axiosIns call later is a drop-in change.
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const STATIC_DISTRICTS = [
  { name: 'Lucknow', value: 'lucknow' },
  { name: 'Allahabad', value: 'allahabad' },
  { name: 'Kanpur Nagar', value: 'kanpur-nagar' },
  { name: 'Varanasi', value: 'varanasi' },
  { name: 'Ghaziabad', value: 'ghaziabad' },
  { name: 'Meerut', value: 'meerut' },
  { name: 'Agra', value: 'agra' },
  { name: 'Rewari', value: 'rewari' },
]

let mockIdCounter = 1
const nextMockId = () => {
  mockIdCounter += 1
  return `impugned-mock-${mockIdCounter}`
}

const seedImpugned = () => [
  {
    _id: 'impugned-mock-seed-1',
    district: 'Lucknow',
    order_date: '12-08-2026',
    created_at: new Date().toISOString(),
  },
  {
    _id: 'impugned-mock-seed-2',
    district: 'Allahabad',
    order_date: '30-07-2026',
    created_at: new Date().toISOString(),
  },
]

export default {
  namespaced: true,
  state: {
    allImpugned: seedImpugned(),
    impugnedDistrictList: STATIC_DISTRICTS,
    isImpugnedLoading: false,
    isNewImpugnedLoading: false,
  },
  getters: {},
  mutations: {
    changeImpugnedLoading(state, val) {
      state.isImpugnedLoading = val
    },
    changeNewImpugnedLoading(state, val) {
      state.isNewImpugnedLoading = val
    },
    setImpugnedDistrictList(state, val) {
      state.impugnedDistrictList = val
    },
    addImpugnedItem(state, item) {
      state.allImpugned.unshift(item)
    },
    removeImpugnedItem(state, _id) {
      state.allImpugned = state.allImpugned.filter(item => item._id !== _id)
    },
  },
  actions: {
    // TODO(backend): replace with `axiosIns.get(defaultConfig.getImpugnedDistrictEndPoint)`
    fetchImpugnedDistrict({ state }) {
      return Promise.resolve({ success: true, districts: state.impugnedDistrictList })
    },

    // TODO(backend): replace with `axiosIns.get(defaultConfig.getImpugnedTrackerListEndPoint, { params: queryParams })`
    fetchImpugnedTracker({ commit, state }, { queryParams }) {
      commit('changeImpugnedLoading', true)

      const { perPage = 10, page = 1, query } = queryParams || {}
      let items = state.allImpugned

      if (query) {
        const q = query.toLowerCase()
        items = items.filter(item => item.district.toLowerCase().includes(q))
      }

      const total = items.length
      const start = (page - 1) * perPage
      const pageItems = items.slice(start, start + perPage)

      commit('changeImpugnedLoading', false)
      return Promise.resolve({
        success: true,
        data: pageItems,
        meta: { total },
      })
    },

    // TODO(backend): replace with `axiosIns.post(defaultConfig.saveImpugnedTrackerEndPoint, payload)`
    findImpugned({ commit }, { ctx, payload }) {
      commit('changeNewImpugnedLoading', true)

      return new Promise(resolve => {
        setTimeout(() => {
          const newItem = {
            _id: nextMockId(),
            district: payload.district,
            order_date: payload.order_date,
            created_at: new Date().toISOString(),
          }
          commit('addImpugnedItem', newItem)
          commit('changeNewImpugnedLoading', false)

          ctx.$bvModal.hide('modal-create-impugned-tracker')
          ctx.$toast({
            component: ToastificationContent,
            props: {
              title: 'Impugned Tracker saved successfully!',
              icon: 'CoffeeIcon',
              variant: 'success',
            },
          })
          resolve({ success: true, data: newItem })
        }, 400)
      })
    },

    // TODO(backend): replace with `axiosIns.post(defaultConfig.deleteImpugnedTrackerEndPoint(_id))`
    deleteImpugnedTracker({ commit }, { ctx, _id }) {
      return new Promise(resolve => {
        commit('removeImpugnedItem', _id)
        ctx.$toast({
          component: ToastificationContent,
          props: {
            title: 'Impugned Tracker deleted successfully!',
            icon: 'CoffeeIcon',
            variant: 'success',
          },
        })
        resolve({ success: true })
      })
    },
  },
}
